import React from "react";
import { Box, Button, Flex, Image, Link, Space, Text } from "@chakra-ui/react";
import Twitter from "../assets/social-media-icons/twitter.png";
import Opensea from "../assets/social-media-icons/opensea.png";
import Email from "../assets/social-media-icons/email_32x32.png";
import Etherscan from "../assets/social-media-icons/etherscan.png";
import LooksRare from "../assets/social-media-icons/looksrare.png";
import * as services from "../services/Services";
import { init, useConnectWallet } from "@web3-onboard/react";

const NavBar = ({
  projectName,
  accounts,
  setAccounts,
  contractAddress,
  connectAccounts,
  connectWallet,
}) => {
  // const isConnected = Boolean(accounts[0]);
  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
  const popEmail = () => {
    alert(
      "Send us an email on how we can improve and what you're looking for in the future!\n You can reach us at hello@basilliusark.com"
    );
  };

  return (
    <Flex justify="space-between" align="center" padding="30px">
      {/* TODO */}
      {/* <Box margin=" 15px">
        <Text color="#e49c00" fontSize="30">
          {projectName}
        </Text>
      </Box> */}

      {/* TODO */}
      {/* <Flex justify="space-around" width="40%" padding="0 75px">
        <Link href="https://www.twitter.com/savegodjira">
          <Image src={Twitter} boxSize="42px" margin="0 15px"></Image>
        </Link>
      </Flex>
      <Flex justify="space-around" width="40%" padding="0 75px">
        <Link href="https://www.twitter.com/savegodjira">
          <Image src={Twitter} boxSize="42px" margin="0 15px"></Image>
        </Link>
      </Flex> */}
      <Box boxSize="42px" margin="0 15px"></Box>
      <Box boxSize="42px" margin="0 15px"></Box>
      <Box boxSize="42px" margin="0 15px"></Box>
      <Box boxSize="42px" margin="0 15px"></Box>
      <Box boxSize="42px" margin="0 15px"></Box>
      {/* <Link href={`https://www.twitter.com/${services.twitter}`}>
        <Image src={Twitter} boxSize="42px" margin="0 15px"></Image>
      </Link> */}
      <Link href={`https://opensea.io/collection/${services.opensea}`}>
        <Image src={Opensea} boxSize="42px" margin="0 15px"></Image>
      </Link>
      {/* <Link onClick={popEmail}>
        <Image src={Email} boxSize="42px" margin="0 15px"></Image>
      </Link> */}
      {/* <Link href={`https://looksrare.org/collections/${contractAddress}`}>
        <Image src={LooksRare} boxSize="42px" margin="0 15px"></Image>
      </Link> */}
      <Link href={`https://etherscan.io/address/${contractAddress}`}>
        <Image src={Etherscan} boxSize="42px" margin="0 15px"></Image>
      </Link>

      {/* Connected */}
      {wallet ? (
        <Button
          backgroundColor="#e49c00"
          borderRadius="5px"
          boxShadow="0px 2px 2px 1px #0F0F0F"
          color="black"
          cursor="pointer"
          fontFamily="inherit"
          padding="15px"
          marginTop="10px"
          margin="0 15px"
        >
          {wallet.accounts[0].address.substring(0, 6) +
            "..." +
            wallet.accounts[0].address.substring(
              wallet.accounts[0].address.length - 4,
              wallet.accounts[0].address.length
            )}
        </Button>
      ) : (
        <Button
          backgroundColor="#e49c00"
          borderRadius="5px"
          boxShadow="0px 2px 2px 1px #0F0F0F"
          color="black"
          cursor="pointer"
          fontFamily="inherit"
          fontSize="100%"
          padding="15px"
          margin="0 15px"
          onClick={connectWallet}
        >
          Connect Wallet
        </Button>
      )}
    </Flex>
  );
};

export default NavBar;
